// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (min-width: 768px){.autoWidth .modal-dialog.modal-content{width:auto}}
`, "",{"version":3,"sources":["webpack://./components/ChooseImageModal.vue"],"names":[],"mappings":"AACA,0BACC,uCAEC,UAAA,CAAA","sourcesContent":["\n@media (min-width: 768px) {\n\t.autoWidth .modal-dialog.modal-content {\n\t\t/* min-width: 600px; */\n\t\twidth: auto;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
